(function () {
  let BrightcoveVideo = {
    init: function () {
      this.hideContentBelowVideo()
    },

    hideContentBelowVideo() {
      const brightcoveContainerElement = document.querySelector('.brightcove-video-main-wrapper')
      const sectionElement = document.querySelector(`#${brightcoveContainerElement.dataset.sectionId}`)
      const hideContentBelowVideo = (brightcoveContainerElement.dataset.hideContentBelowVideo === 'true');
      let hideContentBelowVideoFor = brightcoveContainerElement.dataset.hideContentBelowVideoFor
      hideContentBelowVideoFor = !isNaN(hideContentBelowVideoFor) ? parseInt(hideContentBelowVideoFor) : 764

      // hide all content below the video
      if (hideContentBelowVideo) {
        this.hideAllSiblings(sectionElement.nextSibling);
      }

      // set a timeout to unhide all content after the specified time
      setTimeout(
        () => {
          this.unhideAllSiblings(sectionElement.nextSibling);
        },
        hideContentBelowVideoFor * 1000
      )
    },

    async hideAllSiblings(element) {
      // element maybe be null
      if (element) {
        // only element nodes (type 1) have classList/querySelector/style
        if (element.nodeType === 1) {
          const exemptFromHiding = element.querySelector("[data-exempt-from-hiding='true']")
          if (!exemptFromHiding) {
            await element.classList.add('hide-temporarily')
          }
        }

        // recursively process next node
        this.hideAllSiblings(element.nextSibling)
      }
    },

    async unhideAllSiblings(element) {
      // element maybe be null
      if (element) {
        // only element nodes (type 1) have classList/style; skip text and comment nodes
        if (element.nodeType === 1) {
          element.classList.remove('hide-temporarily')
          element.style.setProperty("display", "block", "important");
        }

        // recursively process next node
        this.unhideAllSiblings(element.nextSibling)

      }
    },
  }

  window.addEventListener('load', (event) => {
    BrightcoveVideo.init()
  })

})()
